import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
///import { useNavigate } from "react-router-dom";

import { UserProfileData } from "../../../FetchAPI";
// import { Link } from "react-router-dom";
// import APIDataFetchLoader from "../../../Others/APIDataFetchLoader";
import VendorRequestValidation from "./VendorRequestValidation";
import NotifyMessage from "../../../Others/NotifyMessage";
import { useAuth } from "../../../../Store/AuthContext";
// import NotifyMessageNoReload from "../../../Others/NotifyMessageNoReload";

const SiteUrl = process.env.REACT_APP_SITEURL;
const WebsiteAPIurl = SiteUrl + "api/Webapi/";

export default function VendorRequestForm({
  RendomTokenfetch,
  responseStatus,
}) {
  const { userID } = useAuth();

  const [ProfileuserData] = UserProfileData(RendomTokenfetch);

  //Personal Form Field

  const fnameref = useRef(ProfileuserData?.firstname || "");
  const lnameref = useRef(ProfileuserData?.lastname || "");
  const emailref = useRef(ProfileuserData?.email || "");

  const [pincode, setpincode] = useState("");

  const addreshref = useRef(ProfileuserData?.address || "");

  const aadhar_frount = useRef(null);
  const aadhar_back = useRef(null);
  const [AaadharNumber, setAaadharNumber] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");

  const [selectedGander, setselectedGander] = useState("");

  const [language, setlanguage] = useState([]);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);

  const [selectedLanguage, setselectedLanguage] = useState("");
  const [selectedState, setSelectedState] = useState("");
  const [selectedcity, setSelectedcity] = useState("");

  //Professional Form Field
  const [professionaltype, setprofessionaltype] = useState([]);
  const [degreeCertification, setdegreeCertification] = useState([]);
  const [passingYear, setpassingYear] = useState([]);

  const [selectedtype, setSelectedtype] = useState("");
  const [selectedDegree, setselectedDegree] = useState("");
  const [selectedpassingYear, setselectedpassingYear] = useState("");
  const [practicestartYear, setpracticestartYear] = useState("");

  const profileDESC = useRef(null);
  const university = useRef(null);
  const barrCouncillNo = useRef(null);
  const IDCardimg = useRef(null);
  const IDcartbackimg = useRef(null);
  const specialization = useRef(null);
  const firamNameref = useRef(null);
  const designationref = useRef(null);

  const [profstates, setprofStates] = useState([]);
  // const [profcities, setprofCities] = useState([]);

  // const [selectedprofstates, setselectedprofstates] = useState("");
  // const [selectedprofcities, setselectedprofcities] = useState("");
  const [court, setcourt] = useState([]);
  // const [profLoading, setprofLoading] = useState(false);

  // const [profselectedState, setprofselectedState] = useState([]);
  // const [profselectedcity, setprofSelectedcity] = useState("");
  // const [selectedCourt, setselectedCourt] = useState("");

  const [practicingcourts, setpracticingcourts] = useState([
    { state: "", city: "", court: "" },
  ]);

  // Function to handle input changes
  const handleInputChange = async (index, field, value) => {
    const updatedCourts = [...practicingcourts];
    updatedCourts[index][field] = value;

    if (field === "state") {
      updatedCourts[index]["city"] = ""; // Reset city when state changes
      updatedCourts[index]["cities"] = await fetchCities(value); // Fetch cities for selected state
    }

    setpracticingcourts(updatedCourts);
  };

  const fetchCities = async (stateId) => {
    try {
      const response = await axios.get(`${WebsiteAPIurl}getAllCity`, {
        params: { state_id: stateId },
      });

      if (response.data.Status === "1") {
        return response.data.allcityData || [];
      } else {
        return [];
      }
    } catch (error) {
      console.error("Error fetching cities:", error);
      return [];
    }
  };

  // Function to add a new row
  const addCourtRow = () => {
    setpracticingcourts([
      ...practicingcourts,
      { state: "", city: "", court: "" },
    ]);
  };

  // Function to remove a row
  const removeCourtRow = (index) => {
    if (practicingcourts.length > 1) {
      setpracticingcourts(practicingcourts.filter((_, i) => i !== index));
    }
  };

  // console.log(practicingcourts);
  //Billing Form Field
  const bankname = useRef(null);
  const accHoldername = useRef(null);
  const [AccNumber, setAccNumber] = useState("");
  const [ifscCode, setifscCode] = useState("");
  const [panNumber, setpanNumber] = useState("");
  const cancelChequeimg = useRef(null);
  const panCardimg = useRef(null);

  const [feilderror, setfeilderror] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isVisibleCourt, setIsVisibleCourt] = useState(false);
  const [isVisibleIDCards, setIsVisibleIdCard] = useState(false);
  const [isVisiblefiramDesig, setIsVisiblefiramDesi] = useState(false);
  // console.log(isVisibleIDCards);

  useEffect(() => {
    if (ProfileuserData?.number) {
      setMobileNumber(ProfileuserData.number);
    }
  }, [ProfileuserData]);

  const handleKeyPress = (e) => {
    const charCode = e.which || e.keyCode;
    if (charCode < 48 || charCode > 57) {
      e.preventDefault();
    }
  };

  const handleMobileChange = (e) => {
    const value = e.target.value;
    if (value.length <= 10) {
      setMobileNumber(value);
    }
  };
  const handleAaadharNumber = (e) => {
    const value = e.target.value;
    if (value.length <= 12) {
      setAaadharNumber(value);
    }
  };
  const handleAccNumber = (e) => {
    const value = e.target.value;
    if (value.length <= 20) {
      setAccNumber(value);
    }
  };
  const handlepincode = (e) => {
    const value = e.target.value;
    if (value.length <= 6) {
      setpincode(value);
    }
  };

  const [OnErrors, setOnErrors] = useState({ pan: "", ifsc: "" });

  const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
  const ifscRegex = /^[A-Z]{4}0[A-Z0-9]{6}$/;

  const handleifscCode = (e) => {
    const value = e.target.value.toUpperCase(); // Convert to uppercase
    setifscCode(value);
    if (value === "") {
      setOnErrors((prev) => ({ ...prev, ifsc: "" }));
    } else if (!ifscRegex.test(value)) {
      setOnErrors((prev) => ({
        ...prev,
        ifsc: "Invalid IFSC format (ABCD0123456)",
      }));
    } else {
      setOnErrors((prev) => ({ ...prev, ifsc: "" }));
    }
  };

  const handlepanNumber = (e) => {
    const value = e.target.value.toUpperCase(); // Convert to uppercase
    setpanNumber(value);
    if (value === "") {
      setOnErrors((prev) => ({ ...prev, pan: "" }));
    } else if (!panRegex.test(value)) {
      setOnErrors((prev) => ({
        ...prev,
        pan: "Invalid PAN format (ABCDE1234F)",
      }));
    } else {
      setOnErrors((prev) => ({ ...prev, pan: "" }));
    }
  };

  const preventSpaceAndEnter = (e) => {
    if (e.key === " " || e.key === "Enter" || /[^A-Za-z0-9]/.test(e.key)) {
      e.preventDefault();
    }
  };

  // Fetch States
  useEffect(() => {
    setLoading(true);
    const FetchSubServiceStateData = async () => {
      try {
        await axios
          .get(`${WebsiteAPIurl}getAllState`, {
            params: { country_id: "101" },
          })
          .then((response) => {
            if (response.data.Status === "1") {
              setStates(response.data.allstateData || []);
              setCities([]);
            } else {
              setStates([]);
              setCities([]);
            }
          });
      } catch (err) {
        setError(err.message);
        // console.error('Error:', err.response ? err.response.data : err.message);
      } finally {
        setLoading(false);
      }
    };
    FetchSubServiceStateData();
  }, [RendomTokenfetch]);

  // Fetch cities when state changes
  useEffect(() => {
    setLoading(true);
    const FetchServiceCityData = async () => {
      try {
        await axios
          .get(`${WebsiteAPIurl}getAllCity`, {
            params: { state_id: selectedState },
          })
          .then((response) => {
            if (response.data.Status === "1") {
              setCities(response.data.allcityData || []);
            }
            if (response.data.Status === "0") {
              setCities([]);
            }
          });
      } catch (err) {
        setError(err.message);
        // console.error('Error:', err.response ? err.response.data : err.message);
      } finally {
        setLoading(false);
      }
    };
    FetchServiceCityData();
  }, [RendomTokenfetch, selectedState]);

  // Fetch Prof States
  useEffect(() => {
    setLoading(true);
    const FetchProfStateData = async () => {
      try {
        await axios
          .get(`${WebsiteAPIurl}getAllState`, {
            params: { country_id: "101" },
          })
          .then((response) => {
            if (response.data.Status === "1") {
              setprofStates(response.data.allstateData || []);
              // setprofCities([]);
            } else {
              setprofStates([]);
              // setprofCities([]);
            }
          });
      } catch (err) {
        setError(err.message);
        // console.error('Error:', err.response ? err.response.data : err.message);
      } finally {
        setLoading(false);
      }
    };
    FetchProfStateData();
  }, [RendomTokenfetch]);

  // Fetch Prodesstional cities when Prodesstional state changes
  // useEffect(() => {
  //   setprofLoading(true);
  //   const FetchProfCityData = async () => {
  //     try {
  //       const responses = await Promise.all(
  //         practicingcourts.map(async (court) => {
  //           if (court.state) {
  //             const response = await axios.get(`${WebsiteAPIurl}getAllCity`, {
  //               params: { state_id: court.state },
  //             });
  //             return {
  //               state: court.state,
  //               city: response.data.allcityData || [],
  //             };
  //           }
  //           return { state: court.state, city: [] };
  //         })
  //       );

  //       // Updating cities based on individual selected states
  //       console.log(responses);
  //       setprofCities(responses);
  //     } catch (err) {
  //       console.error("Error:", err);
  //     } finally {
  //       setprofLoading(false);
  //     }
  //   };

  //   FetchProfCityData();
  // }, [practicingcourts]);

  // useEffect(() => {
  //   setLoading(true);
  //   const FetchProfCityData = async () => {
  //     try {
  //       await axios
  //         .get(`${WebsiteAPIurl}getAllCity`, {
  //           params: { state_id: selectedprofstates },
  //         })
  //         .then((response) => {
  //           if (response.data.Status === "1") {
  //             setprofCities(response.data.allcityData || []);
  //           }
  //           if (response.data.Status === "0") {
  //             setprofCities([]);
  //           }
  //         });
  //     } catch (err) {
  //       setError(err.message);
  //       // console.error('Error:', err.response ? err.response.data : err.message);
  //     } finally {
  //       setLoading(false);
  //     }
  //   };
  //   FetchProfCityData();
  // }, [RendomTokenfetch, selectedprofstates]);

  // Fetch Type on component mount

  useEffect(() => {
    setLoading(true);
    let fdata = new FormData();
    fdata.append("userid", userID);
    const FetchVendorcatData = async () => {
      try {
        await axios
          .post(`${WebsiteAPIurl}professionalDetails`, fdata, {
            headers: {
              Authorization: RendomTokenfetch,
            },
          })
          .then((response) => {
            // console.log("API Response:", response.data);
            if (response.data.Status === "1") {
              setprofessionaltype(response.data.professional || []);
              setpassingYear(response.data.passing_year || []);
              setlanguage(response.data.languages || []);
              setcourt(response.data.courtdata || []);
            }
            if (response.data.Status === "0") {
              setprofessionaltype([]);
              setpassingYear([]);
              setlanguage([]);
              setcourt([]);
            }
          });
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    FetchVendorcatData();
  }, [RendomTokenfetch, userID]);

  // Fetch Dgree when Dgree changes
  useEffect(() => {
    setLoading(true);
    let fdata = new FormData();
    fdata.append("userid", userID);
    fdata.append("professional_id", selectedtype);
    const FetchVendorServiceData = async () => {
      try {
        await axios
          .post(`${WebsiteAPIurl}certificationDetails`, fdata, {
            headers: {
              Authorization: RendomTokenfetch,
            },
          })
          .then((response) => {
            // console.log("API Response:", response.data);
            if (response.data.Status === "1") {
              setdegreeCertification(response.data.degree_certification || []);
            }
            if (response.data.Status === "0") {
              setdegreeCertification([]);
            }
          });
      } catch (err) {
        setError(err.message);
        // console.error('Error:', err.response ? err.response.data : err.message);
      } finally {
        setLoading(false);
      }
    };

    FetchVendorServiceData();
  }, [RendomTokenfetch, selectedtype, userID]);

  const handleProfeType = (e) => {
    setSelectedtype(e.target.value);
    const selectedValue = e.target.value;

    selectedValue === "1" || selectedValue === "2"
      ? setIsVisibleCourt(true)
      : setIsVisibleCourt(false);

    selectedValue === "2"
      ? setIsVisibleIdCard(false)
      : setIsVisibleIdCard(true);

    selectedValue === "3" || selectedValue === "4"
      ? setIsVisiblefiramDesi(true)
      : setIsVisiblefiramDesi(false);

    // console.log(setIsVisibleIdCard);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    let fdata = new FormData();
    fdata.append("user_id", userID);
    //Personal Form Field
    fdata.append("frist_name", fnameref.current?.value || "");
    fdata.append("last_name", lnameref.current?.value || "");
    fdata.append("email", emailref.current?.value || "");
    fdata.append("number", mobileNumber);
    fdata.append("gender", selectedGander);
    fdata.append("address", addreshref.current?.value || "");
    fdata.append("pincode", pincode);
    fdata.append("city", selectedcity);
    fdata.append("state", selectedState);
    fdata.append("language", selectedLanguage);
    fdata.append("aadhar_number", AaadharNumber);
    if (aadhar_frount.current?.files?.length > 0) {
      fdata.append("aadhar_frount", aadhar_frount.current.files[0]);
    }
    if (aadhar_back.current.files[0]) {
      fdata.append("aadhar_back", aadhar_back.current.files[0]);
    }

    //Professional Form Field
    fdata.append("profile_description", profileDESC.current?.value || "");

    fdata.append("professional_type", selectedtype);
    fdata.append("degree", selectedDegree);

    fdata.append("passing_year", selectedpassingYear);
    fdata.append("university_institute", university.current?.value || "");
    fdata.append("bar_council_id", barrCouncillNo.current?.value || "");

    if (isVisibleIDCards) {
      if (IDCardimg.current.files[0]) {
        fdata.append("idcard", IDCardimg.current.files[0]);
      }
      if (IDcartbackimg.current.files[0]) {
        fdata.append("idcard_back", IDcartbackimg.current.files[0]);
      }
    }

    fdata.append("practice_start_year", practicestartYear);
    fdata.append("cpecialization", specialization.current?.value || "");

    if (isVisiblefiramDesig) {
      fdata.append("designation", designationref.current?.value || "");
      fdata.append("farm_name", firamNameref.current?.value || "");
    }

    if (isVisibleCourt) {
      const stateArray = practicingcourts.map((courtRow) => courtRow.state);
      const cityArray = practicingcourts.map((courtRow) => courtRow.city);
      const courtArray = practicingcourts.map((courtRow) => courtRow.court);

      // console.log(stateArray);

      // Append arrays to FormData
      fdata.append("multistate", stateArray);
      fdata.append("multicity", cityArray);
      fdata.append("court", courtArray);
      // fdata.append("court", JSON.stringify(courtArray));

      // fdata.append("multistate", courtRow.state);
      // fdata.append("multicity", courtRow.city);
      // fdata.append("court", courtRow.court);
    }

    //Billing Form Field
    fdata.append("bank_name", bankname.current?.value || "");
    fdata.append("account_holder", accHoldername.current?.value || "");
    fdata.append("account_number", AccNumber);
    fdata.append("ifsc_code", ifscCode);
    fdata.append("pan_number", panNumber);

    if (cancelChequeimg.current.files[0]) {
      fdata.append("cancalled_cheque", cancelChequeimg.current.files[0]);
    }
    if (panCardimg.current.files[0]) {
      fdata.append("pan_card", panCardimg.current.files[0]);
    }

    axios
      .post(`${WebsiteAPIurl}vendor_request`, fdata, {
        headers: {
          Authorization: RendomTokenfetch,
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => {
        // console.log(response.data);
        if (
          fnameref.current.value &&
          lnameref.current.value &&
          mobileNumber &&
          emailref.current.value
        ) {
          if (response.data.Status === "0") {
            // NotifyMessageNoReload(response.data.msg, "danger", true);
            NotifyMessage(response.data.msg, "danger", true);
          }
          if (response.data.Status === "1") {
            NotifyMessage(response.data.msg, "success", true);
          }
        } else {
          // console.log(response.data);
          setfeilderror(VendorRequestValidation(response.data.form_validation));
        }
      });
  };

  if (loading) {
    // return <APIDataFetchLoader />;
  }
  // if (profLoading) {
  //   return <APIDataFetchLoader />;
  // }
  if (error) {
  }
  if (feilderror) {
  }

  return (
    <>
      <div className="row">
        <form
          className="was-validated"
          onSubmit={handleSubmit}
          encType="multipart/form-data"
        >
          {/* Personal Details */}
          <div className="col-lg-12 VendorBoxreq">
            <div className="ls-widget">
              <div className="tabs-box">
                <div className="widget-title">
                  <h3 className="vendorHeading">Personal Details</h3>
                </div>

                <div className="widget-content">
                  <div className="row">
                    <div className="form-group col-lg-4 col-md-6 col-sm-12 mb-3">
                      <label className="form-label" htmlFor="name">
                        First Name<span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        name="firstname"
                        ref={fnameref}
                        defaultValue={ProfileuserData?.firstname || ""}
                        className="form-control"
                        readOnly={!!ProfileuserData?.firstname}
                        required
                      />
                    </div>
                    <div className="form-group col-lg-4 col-md-6 col-sm-12 mb-3">
                      <label className="form-label" htmlFor="name">
                        Last Name<span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        name="lname"
                        ref={lnameref}
                        defaultValue={ProfileuserData?.lastname || ""}
                        className="form-control"
                        readOnly={!!ProfileuserData?.lastname}
                        required
                      />
                    </div>

                    <div className="form-group col-lg-4 col-md-6 col-sm-12 mb-3">
                      <label className="form-label">
                        Email address<span className="text-danger">*</span>
                      </label>
                      <input
                        type="email"
                        name="name"
                        ref={emailref}
                        defaultValue={ProfileuserData?.email || ""}
                        className="form-control"
                        readOnly={!!ProfileuserData?.email}
                        required
                      />
                    </div>

                    <div className="form-group col-lg-3 col-md-6 col-sm-12 mb-3">
                      <label className="form-label">
                        Mobile Number<span className="text-danger">*</span>
                      </label>
                      <div className="input-group ">
                        <input
                          type="text"
                          className="form-control"
                          name="mobileNumber"
                          onChange={handleMobileChange}
                          onKeyPress={handleKeyPress}
                          value={mobileNumber}
                          maxLength={10}
                          inputMode="numeric"
                          readOnly={!!ProfileuserData?.number}
                          required
                        />
                      </div>
                    </div>

                    <div className="form-group col-lg-3 col-md-6 col-sm-12 mb-3">
                      <label className="form-label">
                        Gender<span className="text-danger">*</span>
                      </label>
                      <select
                        className="chosen-select form-control"
                        value={selectedGander}
                        onChange={(e) => setselectedGander(e.target.value)}
                        required
                      >
                        <option value="">Select Gender</option>
                        <option value="Male">Male</option>
                        <option value="Female">Female</option>
                        <option value="Other">Other</option>
                      </select>
                    </div>

                    <div className="form-group col-lg-3 col-md-6 col-sm-12 mb-3">
                      <label className="form-label">
                        Language<span className="text-danger">*</span>
                      </label>
                      <select
                        className="chosen-select form-control"
                        value={selectedLanguage}
                        onChange={(e) => setselectedLanguage(e.target.value)}
                        required
                      >
                        <option value="">Select Language</option>
                        {language.map((lang, index) => (
                          <option value={lang.id} key={index}>
                            {lang.language_name}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="form-group col-lg-3 col-md-6 col-sm-12 mb-3">
                      <label className="form-label">
                        State<span className="text-danger">*</span>
                      </label>
                      <select
                        className="form-control"
                        value={selectedState}
                        onChange={(e) => setSelectedState(e.target.value)}
                        required
                      >
                        <option value="">Select State</option>
                        {states.map((state, index) => (
                          <option value={state.id} key={index}>
                            {state.name}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div className="form-group col-lg-3 col-md-6 col-sm-12 mb-3">
                      <label className="form-label">
                        City<span className="text-danger">*</span>
                      </label>
                      <select
                        className="form-control"
                        value={selectedcity}
                        onChange={(e) => setSelectedcity(e.target.value)}
                        disabled={!cities.length}
                        required
                      >
                        <option value="">Select City</option>
                        {cities.map((city, index) => (
                          <option value={city.id} key={index}>
                            {city.name}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="form-group col-lg-3 col-md-6 col-sm-12 mb-3">
                      <label className="form-label">Pincode</label>
                      <input
                        className="form-control"
                        type="text"
                        name="pincode"
                        onChange={handlepincode}
                        onKeyPress={handleKeyPress}
                        value={pincode}
                        maxLength={6}
                        inputMode="text"
                        placeholder=""
                      />
                    </div>

                    <div className="form-group col-lg-12 col-md-6 col-sm-12 mb-3">
                      <label className="form-label">Address</label>
                      <textarea
                        className="form-control"
                        placeholder=""
                        rows={2}
                        ref={addreshref}
                        defaultValue={ProfileuserData?.address || ""}
                      ></textarea>
                    </div>
                    <div className="form-group col-lg-4 col-md-6 col-sm-12 mb-3">
                      <label className="form-label">Aadhar Number</label>
                      <div className="input-group ">
                        <input
                          type="text"
                          className="form-control"
                          name="AaadharNumber"
                          onChange={handleAaadharNumber}
                          onKeyPress={handleKeyPress}
                          value={AaadharNumber}
                          maxLength={12}
                          inputMode="numeric"
                        />
                      </div>
                    </div>
                    <div className="form-group col-lg-4 col-md-6 col-sm-12 mb-3">
                      <label className="form-label">
                        Aadhar Card Front<span className="text-danger">*</span>
                      </label>
                      <div className="input-group">
                        <input
                          className="form-control"
                          type="file"
                          accept=".png,.jpg,.jpeg"
                          name="aadhar_frount"
                          ref={aadhar_frount}
                          required={responseStatus === "0"}
                        />
                      </div>
                    </div>

                    <div className="form-group col-lg-4 col-md-6 col-sm-12 ">
                      <label className="form-label">
                        Aadhar Card Back<span className="text-danger">*</span>
                      </label>
                      <div className="input-group">
                        <input
                          className="form-control"
                          type="file"
                          accept=".png,.jpg,.jpeg"
                          name="aadhar_back"
                          ref={aadhar_back}
                          required={responseStatus === "0"}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* Professional Details */}
          <div className="col-lg-12 VendorBoxreq">
            <div className="ls-widget">
              <div className="tabs-box">
                <div className="widget-title">
                  <h3 className="vendorHeading">Professional Details</h3>
                </div>
                <div className="widget-content">
                  <div className="row">
                    <div className="form-group col-lg-12 col-md-12 col-sm-12 mb-3">
                      <label className="form-label">Profile Description</label>
                      <textarea
                        className="form-control"
                        name="profileDESC"
                        ref={profileDESC}
                        placeholder=""
                        rows={2}
                      ></textarea>
                    </div>

                    <div className="form-group col-lg-4 col-md-6 col-sm-12 mb-3">
                      <label className="form-label">Professional Type</label>
                      <select
                        name="professionalype"
                        className="form-control"
                        value={selectedtype}
                        onChange={handleProfeType}
                      >
                        <option value="">Select Type</option>
                        {professionaltype &&
                          professionaltype.map((val, index) => (
                            <option value={val.id} key={index}>
                              {val.professional_type}
                            </option>
                          ))}
                      </select>
                      {/* <div className="invalid-feedback">
                        {formValiderror.category && formValiderror.category}
                      </div> */}
                    </div>

                    <div className="form-group col-lg-4 col-md-6 col-sm-12 mb-3">
                      <label className="form-label">Degree/Certification</label>
                      <select
                        className="form-control"
                        value={selectedDegree}
                        onChange={(e) => setselectedDegree(e.target.value)}
                        disabled={!degreeCertification.length}
                      >
                        <option value="">Select Degree</option>
                        {degreeCertification &&
                          degreeCertification.map((value, index) => (
                            <option value={value.id} key={index}>
                              {value.degree_certification}
                            </option>
                          ))}
                      </select>
                    </div>

                    <div className="form-group col-lg-4 col-md-6 col-sm-12 mb-3">
                      <label className="form-label">Passing Year</label>
                      <select
                        className="chosen-select form-control"
                        value={selectedpassingYear}
                        onChange={(e) => setselectedpassingYear(e.target.value)}
                      >
                        <option value="">Select Passing Year</option>
                        {passingYear &&
                          passingYear.map((val, index) => (
                            <option value={val.id} key={index}>
                              {val.year}
                            </option>
                          ))}
                      </select>
                    </div>

                    <div className="form-group col-lg-12 col-md-12 col-sm-12 mb-3">
                      <label className="form-label">Institute/University</label>
                      <textarea
                        name="university"
                        placeholder=""
                        rows={1}
                        className="form-control"
                        ref={university}
                      ></textarea>
                    </div>
                    {/* idCartsShow / Hide */}
                    {isVisibleIDCards && (
                      <div className="row idCartsShow">
                        <div className="form-group col-lg-4 col-md-6 col-sm-12 mb-3">
                          <label className="form-label">
                            Bar Councill ID No.
                            <span className="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            name="barrCouncillNo"
                            className="form-control"
                            ref={barrCouncillNo}
                            required
                          />
                        </div>

                        <div className="form-group col-lg-4 col-md-6 col-sm-12 mb-3">
                          <label className="form-label">Upload ID Card</label>

                          <input
                            className="form-control"
                            type="file"
                            accept=".png,.jpg,.jpeg"
                            name="IDCardimg"
                            ref={IDCardimg}
                          />
                        </div>

                        <div className="form-group col-lg-4 col-md-6 col-sm-12 mb-3">
                          <label className="form-label">
                            Upload ID Card Back
                          </label>

                          <input
                            className="form-control"
                            type="file"
                            accept=".png,.jpg,.jpeg"
                            name="IDcartbackimg"
                            ref={IDcartbackimg}
                          />
                        </div>
                      </div>
                    )}

                    <div className="form-group col-lg-4 col-md-6 col-sm-12 mb-3">
                      <label className="form-label">Practice Start Year</label>
                      <select
                        className="chosen-select form-control"
                        name="practicestartYear"
                        value={practicestartYear}
                        onChange={(e) => setpracticestartYear(e.target.value)}
                      >
                        <option value="">Select Start Year</option>
                        {passingYear &&
                          passingYear.map((val, index) => (
                            <option value={val.id} key={index}>
                              {val.year}
                            </option>
                          ))}
                      </select>
                    </div>
                    {/* statecityCourt Show/hide */}
                    {isVisibleCourt && (
                      <>
                        <div className="headingBOXing d-flex mb-3">
                          <h6 className="fw-600 ">Practicing Courts</h6>
                          <div className="addremovebtnbox d-flex">
                            ({" "}
                            <span className="px-1 AddBTN" onClick={addCourtRow}>
                              {" "}
                              <i
                                className="fa fa-plus-circle"
                                aria-hidden="true"
                              ></i>
                            </span>
                            <span
                              className="px-1 RemoveBTN"
                              onClick={() =>
                                removeCourtRow(practicingcourts.length - 1)
                              }
                            >
                              <i
                                className="fa fa-minus-circle"
                                aria-hidden="true"
                              ></i>
                            </span>{" "}
                            )
                          </div>
                        </div>
                        {practicingcourts.map((courtRow, index) => (
                          <div key={index} className="row statecityCourt">
                            <div className="form-group col-lg-4 col-md-6 col-sm-12 mb-3">
                              <label className="form-label">State</label>
                              <select
                                className="form-control"
                                value={courtRow.state}
                                onChange={(e) => {
                                  handleInputChange(
                                    index,
                                    "state",
                                    e.target.value
                                  );
                                }}
                              >
                                <option value="">Select State</option>
                                {profstates.map((state) => (
                                  <option value={state.id} key={state.id}>
                                    {state.name}
                                  </option>
                                ))}
                              </select>
                            </div>

                            <div className="form-group col-lg-4 col-md-6 col-sm-12 mb-3">
                              <label className="form-label">City</label>
                              {/* <select
                                className="form-control"
                                value={courtRow.city}
                                onChange={(e) => {
                                  handleInputChange(
                                    index,
                                    "city",
                                    e.target.value
                                  );
                                }}
                                disabled={!profcities.length}
                              >
                                <option value="">Select City</option>
                                {profcities.map((city) => (
                                  <option value={city.id} key={city.id}>
                                    {city.name}
                                  </option>
                                ))}
                              </select> */}

                              <select
                                className="form-control"
                                value={courtRow.city}
                                onChange={(e) =>
                                  handleInputChange(
                                    index,
                                    "city",
                                    e.target.value
                                  )
                                }
                                disabled={!courtRow.cities?.length}
                              >
                                <option value="">Select City</option>
                                {courtRow.cities?.map((city) => (
                                  <option value={city.id} key={city.id}>
                                    {city.name}
                                  </option>
                                ))}
                              </select>
                            </div>

                            <div className="form-group col-lg-4 col-md-6 col-sm-12 mb-3">
                              <label className="form-label">Court</label>
                              <select
                                className="chosen-select form-control"
                                value={courtRow.court}
                                onChange={(e) =>
                                  handleInputChange(
                                    index,
                                    "court",
                                    e.target.value
                                  )
                                }
                              >
                                <option value="">Select Court</option>
                                {court.map((courtval, index) => (
                                  <option value={courtval.court_id} key={index}>
                                    {courtval.court_name}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </div>
                        ))}
                      </>
                    )}
                    {/* firmDesignShow Show/hide */}
                    {isVisiblefiramDesig && (
                      <div className="row firmDesignShow">
                        <div className="form-group col-lg-6 col-md-6 col-sm-12 mb-3">
                          <label className="form-label">Firm Name</label>
                          <textarea
                            name="firamNameref"
                            placeholder=""
                            ref={firamNameref}
                            rows={1}
                            className="form-control"
                          ></textarea>
                        </div>
                        <div className="form-group col-lg-6 col-md-6 col-sm-12 mb-3">
                          <label className="form-label">Designation</label>
                          <textarea
                            name="designationref"
                            placeholder=""
                            ref={designationref}
                            rows={1}
                            defaultValue={""}
                            className="form-control"
                          ></textarea>
                        </div>
                      </div>
                    )}

                    <div className="form-group col-lg-12 col-md-6 col-sm-12 mb-3">
                      <label className="form-label">Specialization</label>
                      <textarea
                        name="specialization"
                        placeholder=""
                        ref={specialization}
                        rows={1}
                        className="form-control"
                      ></textarea>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Billing Details */}
          <div className="col-lg-12 VendorBoxreq">
            <div className="ls-widget">
              <div className="tabs-box">
                <div className="widget-title">
                  <h3 className="vendorHeading">Billing Details</h3>
                </div>

                <div className="widget-content">
                  <div className="row">
                    <div className="form-group col-lg-4 col-md-6 col-sm-12 mb-3">
                      <label className="form-label" htmlFor="name">
                        Bank Name
                      </label>
                      <input
                        type="text"
                        name="bankname"
                        ref={bankname}
                        className="form-control"
                      />
                    </div>
                    <div className="form-group col-lg-4 col-md-6 col-sm-12 mb-3">
                      <label className="form-label" htmlFor="name">
                        Name of Account Holder
                      </label>
                      <input
                        type="text"
                        name="accHoldername"
                        ref={accHoldername}
                        className="form-control"
                      />
                    </div>

                    <div className="form-group col-lg-4 col-md-6 col-sm-12 mb-3">
                      <label className="form-label">Account Number</label>
                      <input
                        type="text"
                        name="AccNumber"
                        onChange={handleAccNumber}
                        onKeyPress={handleKeyPress}
                        value={AccNumber}
                        maxLength={20}
                        inputMode="numeric"
                        className="form-control"
                      />
                    </div>

                    <div className="form-group col-lg-6 col-md-6 col-sm-12 mb-3">
                      <label className="form-label">IFSC Code</label>
                      <div className="input-group ">
                        <input
                          type="text"
                          className="form-control"
                          onChange={handleifscCode}
                          onKeyDown={preventSpaceAndEnter}
                          value={ifscCode}
                          maxLength={11}
                          inputMode="text"
                          placeholder="Enter IFSC (ABCD0123456)"
                        />
                      </div>
                      {OnErrors.ifsc && (
                        <span style={{ color: "#db1212", fontSize: "13px" }}>
                          {OnErrors.ifsc}
                        </span>
                      )}
                    </div>

                    <div className="form-group col-lg-6 col-md-6 col-sm-12 mb-3">
                      <label className="form-label">Upload Cheque</label>
                      <div className="input-group">
                        <input
                          className="form-control"
                          type="file"
                          accept=".png,.jpg,.jpeg"
                          name="cancelChequeimg"
                          ref={cancelChequeimg}
                        />
                      </div>
                    </div>
                    <div className="form-group col-lg-6 col-md-6 col-sm-12 mb-3">
                      <label className="form-label">PAN Number</label>
                      <div className="input-group ">
                        <input
                          type="text"
                          className="form-control"
                          name="panNumber"
                          onChange={handlepanNumber}
                          onKeyDown={preventSpaceAndEnter}
                          value={panNumber}
                          maxLength={10}
                          inputMode="text"
                          placeholder="Enter PAN (ABCDE1234F)"
                        />
                      </div>
                      {OnErrors.pan && (
                        <span style={{ color: "#db1212", fontSize: "13px" }}>
                          {OnErrors.pan}
                        </span>
                      )}
                    </div>

                    <div className="form-group col-lg-6 col-md-12">
                      <label className="form-label">Upload PAN Card</label>
                      <div className="input-group">
                        <input
                          className="form-control"
                          type="file"
                          accept=".png,.jpg,.jpeg"
                          name="panCardimg"
                          ref={panCardimg}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="form-group col-lg-12 col-md-12 text-center mt-3">
            <button className="AllsiteButton mt-2" type="submit" name="submit">
              SUBMIT
            </button>
          </div>
        </form>
      </div>
    </>
  );
}
